import { IconButton, styled } from '@mui/material';

const ActionButton = styled(IconButton)({
  '> svg': {
    width: '12px',
    height: '12px',
    position: 'absolute',
    ':hover': {
      width: '14px',
      height: '14px',
    },
  },
  ':disabled': {
    opacity: 0.4,
  },
});

export default ActionButton;
